import type { DocumentStatus } from "@/lib/api";
import { useTranslation } from "react-i18next";

interface StatusConfig {
  bg: string;
  text: string;
  dot: string;
  darkBg: string;
  darkText: string;
}

const STATUS_STYLES: Record<DocumentStatus, StatusConfig> = {
  Pending: {
    bg: "bg-yellow-100",
    text: "text-yellow-700",
    dot: "bg-yellow-500",
    darkBg: "dark:bg-yellow-900/30",
    darkText: "dark:text-yellow-400",
  },
  Signed: {
    bg: "bg-blue-100",
    text: "text-blue-700",
    dot: "bg-blue-500",
    darkBg: "dark:bg-blue-900/30",
    darkText: "dark:text-blue-400",
  },
  Completed: {
    bg: "bg-green-100",
    text: "text-green-700",
    dot: "bg-green-500",
    darkBg: "dark:bg-green-900/30",
    darkText: "dark:text-green-400",
  },
  Rejected: {
    bg: "bg-red-100",
    text: "text-red-700",
    dot: "bg-red-500",
    darkBg: "dark:bg-red-900/30",
    darkText: "dark:text-red-400",
  },
};

interface Props {
  status: DocumentStatus;
}

export function DocumentStatusBadge({ status }: Props) {
  const { t } = useTranslation();
  const s = STATUS_STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${s.bg} ${s.text} ${s.darkBg} ${s.darkText}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {t(`documents.status.${status}`)}
    </span>
  );
}
